import { topics } from "@/mocks/gossip";

export default function CampusTopics() {
  return (
    <section
      id="topics"
      className="bg-gradient-to-b from-background-50 to-background-100 py-14 md:py-20"
    >
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-accent-200 bg-accent-100 px-3 py-1 text-[11px] font-medium text-accent-800">
            <i className="ri-price-tag-3-line"></i> 校园话题库
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            追瓜逛分类，别错过每一个角落
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-500">
            按场景划分的吃瓜地图，宿舍、课堂、操场都在这里实时更新。
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((t) => (
            <a
              key={t.key}
              href="#fresh"
              className={`group relative flex items-start gap-4 overflow-hidden rounded-2xl border p-5 transition hover:-translate-y-1 hover:shadow-lift ${
                t.accent
                  ? "border-accent-200 bg-accent-50 hover:border-accent-300"
                  : "border-background-200 bg-background-50 hover:border-primary-200"
              }`}
            >
              <span
                className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-2xl ${
                  t.accent ? "bg-accent-100" : "bg-primary-100"
                }`}
              >
                {t.emoji}
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3
                    className={`font-heading text-base font-bold ${
                      t.accent ? "text-accent-900" : "text-foreground-950"
                    }`}
                  >
                    {t.name}
                  </h3>
                  <span className="whitespace-nowrap rounded-full bg-foreground-100 px-2 py-0.5 text-[10px] text-foreground-500">
                    {t.postCount} 条
                  </span>
                </div>
                <p className="mt-1.5 text-sm text-foreground-600">{t.desc}</p>
                <span
                  className={`mt-3 inline-flex items-center gap-1 text-xs font-medium ${
                    t.accent ? "text-accent-700" : "text-primary-600"
                  }`}
                >
                  去看看
                  <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}